<!--CC: taken from onboarding-wizard.component.html -> outbound 'Your MTA' section, redesigned to match onboarding-domains style-->
<div class="flex-column gap-3 f-1-0" style="overflow: auto;">

	<!--CC: add MTA button-->
	<div class="flex-row">
		<btn-c endIcon="far fa-plus" (action)="showAddForm = !showAddForm">
			Add MTA
		</btn-c>
	</div>

	<!--CC: add MTA form, shown on button click-->
	<div class="flex-column gap-3 p-3 rounded border animated fadeIn" *ngIf="showAddForm">
		<div class="flex-row gap-2 align-items-center">
			<div class="flex-column gap-1 f-1-0" style="max-width: 40%;">
				<span style="font-size: 0.8em; color: grey; text-transform: uppercase;">Domain</span>
				<div style="position: relative;">
					<input type="text" style="margin-bottom: 0; padding-right: 80px; width: 100%;"
						   placeholder="e.g. example.com"
						   [(ngModel)]="relay.domain"
						   [ngClass]="domainErr && 'validation-error'"
						   (ngModelChange)="domainErr = false;">
					<a class="redborder"
					   style="width: 80px; box-shadow: none; position: absolute; right: 5px; top: 5px; font-style: italic; margin: 0; border: none; cursor: pointer; font-weight: bold;"
					   [ngClass]="{'disabled': !relay.domain || updateMtaInProcess}"
					   (click)="resolveDomainHost()">
						Resolve host
					</a>
				</div>
			</div>
			<div class="flex-column gap-1 f-1-0">
				<span style="font-size: 0.8em; color: grey; text-transform: uppercase;">MTA Host</span>
				<input type="text" style="margin-bottom: 0;"
					   placeholder="e.g. mail.example.com"
					   [(ngModel)]="relay.host">
			</div>
			<div class="flex-column gap-1" style="width: 80px;">
				<span style="font-size: 0.8em; color: grey; text-transform: uppercase;">Port</span>
				<input type="text" style="margin-bottom: 0;"
					   placeholder="25"
					   [(ngModel)]="relay.newPort">
			</div>
		</div>
		<div class="flex-row gap-2 justify-content-end">
			<btn-c variant="outlined" (action)="showAddForm = false;">
				Cancel
			</btn-c>
			<btn-c endIcon="far fa-plus"
				   [isDisabled]="!relay.host || !relay.newPort || !relay.domain || updateMtaInProcess"
				   (action)="addMta();">
				Add
			</btn-c>
		</div>
	</div>

	<!--CC: empty state-->
	<div class="flex-column align-items-center gap-2 py-4 text-muted" *ngIf="!relay?.mtas?.length">
		<i class="far fa-server" style="font-size: 32px;"></i>
		<span>No MTA endpoints configured</span>
	</div>

	<!--CC: MTA list — card per entry, drag-drop reorder-->
	<div cdkDropList class="flex-column gap-2"
		 (cdkDropListDropped)="onDropMta($event)"
		 *ngIf="relay?.mtas?.length">
		<div cdkDrag
			 [cdkDragDisabled]="mta.editMode"
			 *ngFor="let mta of relay.mtas; let mtaIndex = index;"
			 (cdkDragStarted)="onDragStartMta(mta)">

			<!--CC: display mode — card with labeled fields, status, actions-->
			<div class="flex-column border rounded" *ngIf="!mta.editMode">
				<div class="flex-row align-items-center gap-3 p-3">
					<div class="flex-row gap-4 f-1-0">
						<div class="flex-column gap-1" style="flex: 2 0 0;">
							<span style="font-size: 0.8em; color: grey; text-transform: uppercase;">Domain</span>
							<span class="fw-bold">{{mta.domain}}</span>
						</div>
						<div class="flex-column gap-1" style="flex: 3 0 0;">
							<span style="font-size: 0.8em; color: grey; text-transform: uppercase;">Host</span>
							<span>{{mta.host}}</span>
						</div>
						<div class="flex-column gap-1" style="flex: 0 0 50px;">
							<span style="font-size: 0.8em; color: grey; text-transform: uppercase;">Port</span>
							<span>{{mta.port}}</span>
						</div>
					</div>
					<div class="flex-row align-items-center gap-2">
						<!--CC: fixed-width status slot to prevent layout shift-->
						<span style="width: 80px; text-align: center; flex-shrink: 0;">
							<span class="badge" *ngIf="mta.verified === true" style="background: #198754; color: white;">
								<i class="far fa-check-circle" style="margin-right: 3px;"></i>Verified
							</span>
							<span class="badge bg-warning text-dark" *ngIf="mta.verified === false">
								<i class="far fa-exclamation-triangle" style="margin-right: 3px;"></i>Failed
							</span>
							<span class="badge bg-secondary" *ngIf="mta.loading">
								<i class="far fa-spinner fa-spin" style="margin-right: 3px;"></i>Checking...
							</span>
						</span>
						<btn-c variant="outlined" class="shrunk"
							   [isDisabled]="updateMtaInProcess"
							   (action)="verifyMta(mta)">
							Check Connection
						</btn-c>
						<btn-c variant="outlined" class="shrunk"
							   [isDisabled]="updateMtaInProcess"
							   (action)="setMTAForEdit(mta)">
							Edit
						</btn-c>
						<btn-c variant="outlined" class="shrunk" color="danger"
							   [isDisabled]="updateMtaInProcess"
							   (action)="confirmDeleteMta(mtaIndex)">
							Delete
						</btn-c>
					</div>
				</div>
			</div>

			<!--CC: edit mode — inline form-->
			<div class="flex-column border rounded p-3 gap-3" *ngIf="mta.editMode">
				<div class="flex-row gap-2 align-items-center">
					<div class="flex-column gap-1 f-1-0" style="max-width: 40%;">
						<span style="font-size: 0.8em; color: grey; text-transform: uppercase;">Domain</span>
						<input type="text" style="margin-bottom: 0;"
							   placeholder="Domain"
							   [(ngModel)]="mtaInEdit.domain"
							   [ngClass]="domainErr && 'validation-error'"
							   (ngModelChange)="domainErr = false;">
					</div>
					<div class="flex-column gap-1 f-1-0">
						<span style="font-size: 0.8em; color: grey; text-transform: uppercase;">MTA Host</span>
						<input type="text" style="margin-bottom: 0;"
							   placeholder="MTA"
							   [(ngModel)]="mtaInEdit.host">
					</div>
					<div class="flex-column gap-1" style="width: 80px;">
						<span style="font-size: 0.8em; color: grey; text-transform: uppercase;">Port</span>
						<input type="text" style="margin-bottom: 0;"
							   placeholder="Port"
							   [(ngModel)]="mtaInEdit.port">
					</div>
				</div>
				<div class="flex-row gap-2 justify-content-end">
					<btn-c variant="outlined"
						   (action)="mtaInEdit.editMode = false; mtaInEdit = null;">
						Cancel
					</btn-c>
					<btn-c [isDisabled]="!mtaInEdit.host || !mtaInEdit.port || !mtaInEdit.domain || updateMtaInProcess"
						   (action)="updateEmailRelayConfig(dic.CONSTANTS.erSettingsActions.mta, 'edit');">
						Save
					</btn-c>
				</div>
			</div>
		</div>
	</div>
</div>
